export const DEFAULT_POSITION = {
  x: 0,
  y: 0,
};

export const DEFAULT_ROTATION = {
  degrees: 0,
};

export const DEFAULT_TEXT_CONFIGURATION = {
  font: {
    family: "Poppins",
    size: 38,
    decoration: "none",
    variant: "normal",
    weight: "normal",
    lineHeight: 1.2,
    color: "#ffffff",
  },
  stroke: {
    width: 5,
    color: "#000000",
  },
  background: {
    color: "transparent",
    radius: 0,
  },
  rotation: {
    degrees: 0,
  },
  alignment: {
    horizontal: "center",
    vertical: "center",
  },
};
